import QueryRule from '~/scripts/services/model/query-rule';
import QueryVariable from '~/scripts/services/model/query-variable';
import QueryWhereRule from '~/scripts/services/model/query-where-rule';

export default class ModalQueryMultipleFilterValuesController {
	/* @ngInject */
	/**
	 * @param {any} $scope
	 * @param {import('angular').ui.bootstrap.IModalInstanceService} $uibModalInstance
	 * @param {any} KTranslate
	 * @param {any} options
	 * @param {QueryRule | QueryWhereRule | QueryVariable} rule
	 * @param {any} value
	 * @param {any} node
	 */
	constructor($scope, $uibModalInstance, KTranslate, options, rule, value, node) {
		this.$scope = $scope;
		this.$uibModalInstance = $uibModalInstance;
		this.KTranslate = KTranslate;
		this.node = node;
		this.options = options;
		this.rule = rule;
		this.value = value;

		// @ts-ignore
		this.order = this.rule.isa || this.node?.kid || this.rule.field;

		(async () => this.setTitle())();
	}

	async setTitle() {
		// @ts-ignore
		this.title = this.rule.label || this.rule.name || this.node?.name || this.rule.field;

		if (this.node && this.node.linker_kid !== '0') {
			this.title += ` :: ${this.node.linker_info?.name
			|| await this.KTranslate.request(this.$scope, this.node.linker_kid)}`;
		}
	}

	close() {
		return this.$uibModalInstance.close(this.value);
	}
}
